import React, { Component } from 'react';

class UserProfileDocumentation extends Component {
    render() {
        return (
            <div>
              <p>
                You can set up a profile by going to <a href="https://zequencer.io/user/">zequencer.io/user/</a>. 
              </p>
              <p className="sub-header">
                Username
              </p>
              <p>
                You can choose a username to go by on Zequencer.
              </p>
              <p>
                Once you've chosen a username, others can access your profile page 
                by going to zequencer.io/*USER_NAME_YOU_CHOSE*.
              </p>
              <p className="sub-header">
                Spotlight Tracks
              </p>
              <p>
                You can choose what songs to spotlight at the front of your profile.
              </p>
              <p className="sub-header">
                Mixes
              </p>
              <p>
                You can create mixes with songs.
              </p>
              <p className="sub-header">
                Connect
              </p>
              <p>
                You can connect with other creators by clicking the <b>Connect</b> button.
                Once connected, you can share private sequences with them.
              </p>
              <p>
                If you connect with someone, the other person needs to confirm that they wish
                to connect with you.
              </p>
              <p>
                To see what requests to connect people have made, go to the <b>Links</b> tab
                on your profile page.
              </p>
            </div>
        );
    }
}

export default UserProfileDocumentation;
